export default {
    // Used to get the localized value of a text from the text resources that have been loaded from the MWM2 Text application
    textResource: (state) => (textName) => {
        return state.text[textName];
    },
    // Determines whether the question can be updated. They aren't allowed to do this when navigating back and the skip option is true
    editingAllowed: (state) => (questionData, checkForOuterfield = true) => {
        if (!questionData.subQuestions) {
            let outerFieldAnswer = questionData.answers.filter((answer) => answer.type === `OuterField`);

            if (checkForOuterfield && outerFieldAnswer.length > 0 && outerFieldAnswer[0].isChecked) return false;
            else if (questionData.settings && questionData.settings.skip && state.page.isCompleted) return false;
            else if (questionData.isFrozen === true) return false;
            else return true;
        } else {
            if (questionData.isFrozen === true) return false;
            else return true;
        }
    },
};
